import React, { Component } from 'react';
import './css/AffiliateViewTags.css'
export const AffiliateViewTags = (props) => {
  return (
      <div className="tagrow">
        <p className="TagName2">{props.value}</p>
      </div>
  );
}


